import { PayloadAction } from '../../../core/models/action';

export const INCREMENT_LOADER_COUNT = 'INCREMENT_LOADER_COUNT';
export const DECREMENT_LOADER_COUNT = 'DECREMENT_LOADER_COUNT';

export class IncrementLoaderCount implements PayloadAction {
    readonly type = INCREMENT_LOADER_COUNT;
    constructor(public payload?) { }
}
export class DecrementLoaderCount implements PayloadAction {
    readonly type = DECREMENT_LOADER_COUNT;
    constructor(public payload?) { }
}

export type LoaderActions = IncrementLoaderCount | DecrementLoaderCount;
